import { render } from "./AppMessage.vue?vue&type=template&id=0771b74d"
import script from "./AppMessage.vue?vue&type=script&lang=js"
export * from "./AppMessage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GitLabRunner\\builds\\ThRl3iSS9\\0\\clients\\safan-darley\\kiosk.safandarley.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__